import axiosInstance from '../../api';
import { Shift } from '../resourceTracking/types';
import { BreakDisplayDto } from './types';

/**
 * Fetches the break-time display state for a cell + shift.
 */
export const getBreakDisplay = async (
  mCellId: string,
  shift: Shift,
): Promise<BreakDisplayDto> => {
  const response = await axiosInstance.get<BreakDisplayDto>(
    '/api/BreakDisplay',
    {
      params: { mCellId, shift },
    },
  );
  return response.data;
};
